import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=0a3f1bdc&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f1bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3f1bdc')) {
      api.createRecord('0a3f1bdc', component.options)
    } else {
      api.reload('0a3f1bdc', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=0a3f1bdc&scoped=true&", function () {
      api.rerender('0a3f1bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VutC123rHWFy/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports